<template>
  <el-dialog
    :visible.sync="dialogVisible"
    custom-class="online-project-report-edit-dialog"
    :modal="true"
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    :width="'80%'"
  >
    <div style="margin-bottom:10px; width: 100%;">
      <el-card style="height: 65vh;">
        <div v-show="md5" id="ProjectReportEditor" style="height:65vh !important"></div>
      </el-card>
      <span slot="footer">
        <div style="margin-left: 65vw;margin-top: 10px;">
          <el-button plain size="small" @click="cancleEdit">取消</el-button>
          <el-button type="primary" size="small" @click="saveReport">导出报告</el-button>
        </div>
      </span>
    </div>
  </el-dialog>
</template>
<script>
// import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'
// import WPSOfficeSDK from '../../../../assets/weboffice/web-office-sdk-v1.1.2.es'

const { download } = require('../../../project/src/constant/utils')

export default {
  data() {
    return {
      dialogVisible: false,
      previewUrl: '',
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          url: '',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: `${window.host}/track`,
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            autosave: true,
            comments: false,
            feedback: false,
            // forcesave: false,
            submitForm: false,
            compactHeader: false,
            compactToolbar: false,
            toolbarNoTabs: false,
            hideRightMenu: true,
            hideRulers: true,
            // zoom: -2,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
            review: false,
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'edit',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  mounted() {
    this.config.events = {
      onError: this.destoryEditor,
      onRequestClose: this.destoryEditor,
    }
  },
  methods: {
    async open({ url, md5, documentType, fileType, originalname }) {
      console.log('🚀 ~ file: ProjectReportEditor.vue:104 ~ open ~ documentType:', documentType)
      this.dialogVisible = true
      this.previewUrl = url
      this.md5 = md5
      this.config.documentType = documentType
      this.config.document.fileType = fileType
      this.config.document.key = `${this.md5}-${Date.now()}`
      this.config.document.title = originalname
      this.config.document.url = url
      console.log('🚀 ~ file: ProjectReportEditor.vue:112 ~ open ~ this.config:', this.config)
      this.$nextTick(async () => {
        if (!this.docEditor) {
          this.docEditor = new window.DocsAPI.DocEditor('ProjectReportEditor', this.config)
        }
      })
    },
    async saveReport() {
      const text = '正在客户公司项目盘点，请稍等...'
      const loading = this.$loading({
        lock: true,
        text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.destoryEditor()
      try {
        // 等待20s，让文件结果保存和上传
        await this.sleep(10000)
        const res = await app.service('file').downloadOnlyOfficeFile({ md5: this.md5 })
        if (res && res.data) {
          console.info(res)
          download({ md5: res.data.md5 })
          app.service('radish').addKpi({
            type: '市场报告',
            content: { md5: this.md5 },
          })
          this.dialogVisible = false
          this.$emit('confirm')
        }
      } catch (e) {
        this.$message.error(`导出报告出错，请联系管理员`)
      }
      loading.close()
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    cancleEdit() {
      this.destoryEditor()
      this.dialogVisible = false
      this.$emit('cancle')
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
  },
}
</script>
<style>
.online-project-report-edit-dialog {
  margin-top: 8vh !important;
}
.online-project-report-edit-dialog .el-dialog__header {
  padding: 0px !important;
}
.online-project-report-edit-dialog .el-card__body {
  height: 64vh !important;
  padding: 0px !important;
}
.online-project-report-edit-dialog .el-dialog__body {
  padding: 10px 20px !important;
}
.online-project-report-edit-dialog .main-title {
  font-size: 18px;
  color: #9e9ea7;
}
.online-project-report-edit-dialog .sub-title {
  color: #9e9ea7;
}
</style>
